export const PUNCH_OUT_SESSION = 'punchout-session';
